const orderDetails = {
  'orderDetails.title': 'تفاصيل الطلب',
  'orderDetails.tab.goodsList': 'قائمة السلع',
  'orderDetails.tab.payments': 'معلومات الدفع',
  'orderDetails.tab.shipments': 'معلومات الشحن',
  'orderDetails.tab.logistics': 'معلومات اللوجستيات',
  'orderDetails.tab.operationLog': 'سجل العمليات',

  'orderDetails.fetch.orderId.empty': 'معرف الطلب لا يمكن أن يكون فارغًا',

  'orderDetails.content.orderInfo.title': 'معلومات الطلب',
  'orderDetails.export.productList': 'تصدير قائمة المنتجات',
  'orderDetails.export.exporting': 'جارٍ تصدير قائمة المنتجات...',
  'orderDetails.export.success.message': 'تم التصدير بنجاح',
  'orderDetails.export.success.description': 'تم تصدير قائمة المنتجات بنجاح، يرجى التحقق من مجلد التنزيلات',
  'orderDetails.export.failed': 'فشل التصدير، يرجى المحاولة مرة أخرى لاحقًا',

  'orderDetails.content.customerInfo.title': 'معلومات العميل المشتري',
  'orderDetails.content.customerInfo.shopId': 'معرف المتجر',
  'orderDetails.content.customerInfo.shopName': 'اسم المتجر',

  'orderDetails.content.shippingInfo.title': 'معلومات الاستلام',
  'orderDetails.content.shippingInfo.recipientName': 'اسم المستلم',
  'orderDetails.content.shippingInfo.phone': 'الهاتف/الخط الأرضي',
  'orderDetails.content.shippingInfo.postalCode': 'الرمز البريدي',
  'orderDetails.content.shippingInfo.email': 'البريد الإلكتروني',
  'orderDetails.content.shippingInfo.address': 'عنوان الاستلام',

  'orderDetails.content.amountInfo.title': 'معلومات المبلغ',
  'orderDetails.content.amountInfo.goodsAmount': 'مبلغ البضاعة',
  'orderDetails.content.amountInfo.otherAmount': 'رسوم أخرى',

  'orderDetails.feeType': 'نوع الرسوم',
  'orderDetails.feeAmount': 'المبلغ',

  'orderDetails.productList.partsNum': 'رقم القطعة',
  'orderDetails.productList.productTitle': 'تفاصيل المنتج',
  'orderDetails.productList.replacePartsNum': 'رقم القطعة البديلة',
  'orderDetails.productList.unitPrice': 'السعر الفردي',
  'orderDetails.productList.totalPrice': 'السعر الإجمالي',
  'orderDetails.productList.totalQuantity': 'الكمية الإجمالية',
  'orderDetails.productList.shippedQuantity': 'الكمية المسلمة',

  'orderDetails.operationRecord.operationType': 'نوع العملية',
  'orderDetails.operationRecord.operationUser': 'المشغل',
  'orderDetails.operationRecord.operationDate': 'تاريخ العملية',

  'orderDetails.payments.paymentId': 'معرف فاتورة الدفع',
  'orderDetails.payments.paymentMethod': 'طريقة الدفع',
  'orderDetails.payments.paymentAmount': 'مبلغ الدفع',
  'orderDetails.payments.paymentDate': 'تاريخ الدفع',
  'orderDetails.payments.payer': 'المدفوع له',
  'orderDetails.payments.payerContact': 'معلومات الاتصال',
  'orderDetails.payments.description': 'الوصف',
};

export default orderDetails;
